import { SelectOption, SelectOptions } from "@/types/snap-ui";
import { UserOccupation } from "@/types/graphql";

type Occupation = {
  id: string;
  name: string;
  prompt: string;
};

const Occupation: Array<Occupation> = [
  {
    id: UserOccupation.StudentOrParticipant,
    name: "Participant",
    prompt: "I’m a student or participant in a fundraiser",
  },
  {
    id: UserOccupation.Parent,
    name: "Parent",
    prompt: "I’m a parent/guardian of a student",
  },
  {
    id: UserOccupation.GroupLeader,
    name: "Group Leader",
    prompt: "I’m a group leader (coach, band leader, teacher, etc.)",
  },
  {
    id: UserOccupation.SchoolDirector,
    name: "School Director",
    prompt:
      "I’m a school director (athletic/activities director, principal, etc.)",
  },
  {
    id: UserOccupation.DistrictAdministrator,
    name: "District Administrator",
    prompt: "I’m a district administrator",
  },
  {
    id: UserOccupation.StateAdministrator,
    name: "State Administrator",
    prompt: "I’m a state administrator",
  },
  {
    id: UserOccupation.FinancialAdministrator,
    name: "Financial Administrator",
    prompt: "I’m a financial administrator (accountant, bookkeeper, etc.)",
  },
  {
    id: UserOccupation.Other,
    name: "Other",
    prompt: "I don’t see my role listed, but want to use Snap! Mobile",
  },
  {
    id: UserOccupation.Unknown,
    name: "Unknown",
    prompt: "",
  },
];

type SignUpOccupationRule = {
  check: (consumer: string, redirectTo: string) => boolean;
  value: UserOccupation | undefined;
};

export const SignUpOccupationRules: Array<SignUpOccupationRule> = [
  {
    check: (consumer: string, redirectTo: string) =>
      consumer === "raise" && /from=mktingsite/i.test(redirectTo),
    value: undefined,
  },
  {
    check: (consumer: string, redirectTo: string) =>
      consumer === "raise" && /\/user_workflows\//i.test(redirectTo),
    value: UserOccupation.GroupLeader,
  },
  {
    check: (consumer: string) => consumer === "raise",
    value: UserOccupation.StudentOrParticipant,
  },
];
export const getPrePopulatedOccupation = (
  consumer?: string,
  redirectTo?: string
): UserOccupation | undefined => {
  return SignUpOccupationRules.find((rule) =>
    rule.check(consumer || "", redirectTo || "")
  )?.value;
};

export const getSignUpOccupations = (): SelectOptions => {
  return Occupation.filter(
    (occupation) => occupation.id !== UserOccupation.Unknown
  ).map(
    (occupation): SelectOption => ({
      name: occupation.prompt,
      value: occupation.id,
    })
  );
};

export const getUserUpdateOccupations = (): SelectOptions => {
  return Occupation.filter(
    (occupation) => occupation.id !== UserOccupation.Unknown
  ).map(
    (occupation): SelectOption => ({
      name: occupation.name,
      value: occupation.id,
    })
  );
};

export const getOccupationName = (id?: string): string | undefined => {
  return Occupation.find((occupation) => occupation.id === id)?.name;
};
